import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class LeagueMemberService {
    url: string = environment.api.endpoint;

    constructor(private http: HttpClient) { }

    getById(id: string): any {
        return this.http.get(`${this.url}/leaguemember/${id}`);
    }

    getAllByLeagueId(filter: any): any {
        return this.http.get(`${this.url}/leaguemembers/league`, { params: filter });
    }

    getAvailableByLeagueIterationId(filter: any): any {
        return this.http.get(`${this.url}/leaguemembers/available/leagueiteration`, { params: filter });
    }

    getAllByOrganization(filter: any): any {
        return this.http.post(`${this.url}/leaguemembers/organization`, filter);
    }

    create(data: any): any {
        return this.http.post(`${this.url}/leaguemember/create`, data);
    }

    createBatch(data: any): any {
        return this.http.post(`${this.url}/leaguemember/createbatch`, data);
    }

    update(id: string, data: any): any {
        return this.http.post(`${this.url}/leaguemember/update/${id}`, data);
    }

    delete(data: any): any {
        return this.http.post(`${this.url}/leaguemember/delete`, data);
    }
}

